export type Product = {
  slug: string;
  sku: string;
  name: string;
  category: string;
  short: string;
  description: string;
  specs: Record<string, string | undefined>;
  images: Array<string>;
  prixPublicConseille?: number;
  ficheTechnique: string;
};

export const products = [
  {
    slug: "kaiser-safe-6-armes",
    sku: "KaiserSafe6",
    name: "KaiserSafe — 6 armes",
    category: "Armoires à fusils",
    short:
      "Armoire de stockage conçue pour accueillir jusqu’à 6 armes longues avec fixation murale et au sol.",
    description:
      "Construction acier, parois renforcées. Conçue pour un stockage sûr de 6 armes longues. Pré-perçages pour ancrage mural et au sol.",
    specs: {
      Capacité: "Jusqu’à 6 armes longues",
      Serrure: "Serrure mécanique à clé, fournie avec deux clés",
      Pênes:
        "Mécanisme de verrouillage multipoints reposant sur des pênes cylindriques en acier massif",
      "Epaisseur de la paroi":
        "Structure en acier avec parois de 2 mm assurant rigidité et résistance",
      Finition:
        "Traitement de surface par thermolaquage époxy noir pour une protection durable",
      Poids: "45 kg",
      "Dimensions intérieures (HxLxP)": "1320 x 345 x 220 mm",
      "Dimensions extérieures (HxLxP)": "1495 x 350 x 280 mm",
      "Dimensions coffre intérieur (HxLxP)": "150 x 330 x 170 mm",
      "Coffre interne":
        "Compartiment intérieur sécurisé, équipé d’une serrure indépendante",
      "Trous de fixation":
        "Points de fixation prévus à l’arrière et à la base pour ancrage mural et au sol",
      Accessoires: "Kit de fixation et tapis de protection intérieure inclus",
      Garantie: "1 an",
    },
    images: [
      "/KS6/armoire-a-fusils-kaisersafe-6-armes-serrure-a-cles face.webp",
      "/KS6/armoire-a-fusils-kaisersafe-6-armes-serrure-a-cles-bas.webp",
      "/KS6/armoire-a-fusils-kaisersafe-6-armes-serrure-a-cles-coffre-interieur.webp",
      "/KS6/armoire-a-fusils-kaisersafe-6-armes-serrure-a-cles-herobanner.webp",
      "/KS6/armoire-a-fusils-kaisersafe-6-armes-serrure-a-cles-lateral.webp",
      "/KS6/armoire-a-fusils-kaisersafe-6-armes-serrure-a-cles-situation.webp",
      "/KS6/armoire-a-fusils-kaisersafe-6-armes-serrure-a-cles-usps.webp",
      "/KS6/armoire-a-fusils-kaisersafe-6-armes-serrure-a-cles-with-riffles.webp",
    ],
    // prixPublicConseille: 220,
    ficheTechnique: "/KS6/Fiche Technique KS6.pdf",
  },
  {
    slug: "kaiser-safe-8-armes",
    sku: "KaiserSafe8",
    name: "KaiserSafe — 8 armes",
    category: "Armoires à fusils",
    short:
      "Armoire pour armes longues offrant une capacité étendue, avec aménagements intérieurs dédiés et protection des équipements.",
    description:
      "Cette armoire permet le stockage organisé de jusqu’à 8 armes longues. Elle intègre des renforts structurels, des charnières protégées et des espaces dédiés aux accessoires, pour un usage régulier en toute sécurité.",
    specs: {
      Capacité: "Jusqu’à 8 armes longues",
      Poids: "55 kg",
      Finition:
        "Finition noire par peinture époxy cuite, garantissant une bonne tenue dans le temps",
      Serrure: "Système de fermeture à clé fourni avec deux clés",
      Pênes:
        "Verrouillage assuré par pênes en acier répartis sur plusieurs points",
      "Dimensions extérieures (HxLxP)": "1495 x 450 x 280 mm",
      "Dimensions intérieures (HxLxP)": "1320 x 445 x 220 mm",
      "Dimensions coffre intérieur (HxLxP)": "150 x 440 x 170 mm",
      "Coffre interne":
        "Coffre intérieur indépendant pour munitions ou documents",
      "Epaisseur de la paroi": "Corps en acier avec épaisseur de paroi de 2 mm",
      Accessoires: "Tapis de fond et éléments de fixation fournis",
      Garantie: "1 an",
    },
    images: [
      "/KS8/armoire-a-fusils-kaisersafe-8-armes-serrure-a-cles-face.webp",
      "/KS8/armoire-a-fusils-kaisersafe-8-armes-serrure-a-cles-coffre-interieur.webp",
      "/KS8/armoire-a-fusils-kaisersafe-8-armes-serrure-a-cles-ouverte-remplie.webp",
      "/KS8/armoire-a-fusils-kaisersafe-8-armes-serrure-a-cles-ouverte.webp",
      "/KS8/armoire-a-fusils-kaisersafe-8-armes-serrure-a-cles-situation.webp",
      "/KS8/armoire-a-fusils-kaisersafe-8-armes-serrure-a-cles-USPs.webp",
    ],
    // prixPublicConseille: 245,
    ficheTechnique: "/KS8/Fiche Technique KS8.pdf",
  },
  {
    slug: "kaiser-safe-12-armes",
    sku: "KaiserSafe12",
    name: "KaiserSafe — 12 armes",
    category: "Armoires à fusils",
    short:
      "Armoire de grande capacité destinée au rangement sécurisé de collections importantes d’armes longues.",
    description:
      "Modèle haute capacité conçu pour le stockage de jusqu’à 12 armes longues. Son agencement intérieur optimise la protection des armes et des accessoires, tout en garantissant une structure robuste et stable.",
    specs: {
      Capacité: "Jusqu’à 12 armes longues",
      Finition:
        "Revêtement époxy noir appliqué par thermolaquage pour une résistance accrue à l’usure",
      Pênes:
        "Dispositif de fermeture multipoints avec pênes en acier de forte section",
      Serrure: "Serrure mécanique à clé avec jeu de deux clés",
      Poids: "80 kg",
      "Epaisseur de la paroi":
        "Structure en acier avec parois de 2 mm d’épaisseur",
      "Dimensions intérieures (HxLxP)": "1475 x 695 x 300 mm",
      "Dimensions intérieures (HxLxP) sous coffre intérieur":
        "1325 x 460 x 300 mm",
      "Dimensions intérieures (HxLxP) partie latérale droite":
        "1480 x 235 x 300 mm",
      "Dimensions coffre intérieur (HxLxP)": "150 x 450 x 170 mm",
      "Dimensions extérieures (HxLxP)": "1495 x 700 x 330 mm",
      "Largeur des tablettes amovibles": "230 mm",
      "Coffre interne":
        "Compartiment sécurisé intégré pour munitions ou documents",
      "Trous de fixation":
        "Système de fixation prévu pour ancrage mural et au sol",
      Accessoires: "Accessoires d’installation et tapis de protection inclus",
      Garantie: "1 an",
    },
    images: [
      "/KS12/armoire-a-fusils-kaisersafe-12-armes-serrure-a-cles-fermée.webp",
      "/KS12/armoire-a-fusils-kaisersafe-12-armes-serrure-a-cles-ouverte-complete.webp",
      "/KS12/armoire-a-fusils-kaisersafe-12-armes-serrure-a-cles-ouverte.webp",
      "/KS12/armoire-a-fusils-kaisersafe-12-armes-serrure-a-cles-USPs.webp",
    ],
    // prixPublicConseille: 340,
    ficheTechnique: "/KS12/Fiche Technique KS12.pdf",
  },
];
